import instance from '@/utils/axios';

export function getTask() {
  return instance.get('/auth/task');
}

/**
 * 获取任务信息
 * @param {string} id taskId
 * @returns
 */
export function getDeviceMap(id) {
  return instance.get('/devicemap/deviceMap', { params: { id } });
}

/**
 * 任务回放
 * @param {{beginTime: number, endTime: number, taskId: string, sn: Array<any>}} data
 * @returns {any}
 */
export function replay(data) {
  return instance.post('/devicemap/replay', data);
}

/**
 * 获取设备参数
 * @param {string} taskId
 * @returns
 */
export function getDevicemapParam(taskId) {
  return instance.get('/devicemap/getDevicemapParams', { params: { taskId } });
}

/**
 * 设置设备地图参数
 * @param {{ taskId:string, devicemapParamItems: { id: string, itemCode: string, itemName: string, itemSort: number,linkId, mapType:string, remarks: string, value: string } }} data
 * @returns {any}
 */
export function saveDevicemapParam(data) {
  return instance.post('/devicemap/saveDevicemapParams', data);
}

/**
 * 更新设备地图
 * @param {string} id taskId
 * @returns {any}
 */
export function renewDeviceMap(id) {
  return instance.get('/devicemap/renewDeviceMap', { params: { id } });
}
